export const getMemberToken = () => sessionStorage.getItem("flen-member") || "";
export const getMemberInfo = () => {
  try {
    return JSON.parse(sessionStorage.getItem("flen-member-info") || "null");
  } catch {
    return null;
  }
};
export const setMemberSession = (token, member) => {
  sessionStorage.setItem("flen-member", token);
  sessionStorage.setItem("flen-member-info", JSON.stringify(member));
};
export const clearMemberSession = () => {
  sessionStorage.removeItem("flen-member");
  sessionStorage.removeItem("flen-member-info");
};
export const memberHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getMemberToken()}`,
});
